import {ProjectReferencePhoto} from './project-reference-photo';
import {Identifiable} from './identifiable';
import {Photo} from './photo';

export interface ProjectReferenceDetailResponse extends Identifiable{
    name: string|null;
    companyName: string|null;
    imageUrl: string|null;
    description: string|null;
    properties: {[key: string]: any|null};
    city: string|null;
    street: string|null;
    houseNumber: string|null;
    postCode: string|null;
    longitude: number|null;
    latitude: number|null;
    photos: ProjectReferencePhoto[];
    primaryPhoto: Photo|null;
    status: status;
    companyLogo: string|null;
    commercialProjectName: string|null;
    kvwNumber: string|null;
}

export type status = 'Concept'|'Published';

export const propertyOrder = {
    phase: 0,
    clientName: 10,
    start: 20,
    end: 30,
    code: 40
};
